/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetDeliverFeeKrAmountlListRespVo } from './GetDeliverFeeKrAmountlListRespVo';
import {
    GetDeliverFeeKrAmountlListRespVoFromJSON,
    GetDeliverFeeKrAmountlListRespVoFromJSONTyped,
    GetDeliverFeeKrAmountlListRespVoToJSON,
    GetDeliverFeeKrAmountlListRespVoToJSONTyped,
} from './GetDeliverFeeKrAmountlListRespVo';

/**
 * 
 * @export
 * @interface ResponseListGetDeliverFeeKrAmountlListRespVo
 */
export interface ResponseListGetDeliverFeeKrAmountlListRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListGetDeliverFeeKrAmountlListRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListGetDeliverFeeKrAmountlListRespVo
     */
    message?: string;
    /**
     * 
     * @type {Array<GetDeliverFeeKrAmountlListRespVo>}
     * @memberof ResponseListGetDeliverFeeKrAmountlListRespVo
     */
    data?: Array<GetDeliverFeeKrAmountlListRespVo>;
}

/**
 * Check if a given object implements the ResponseListGetDeliverFeeKrAmountlListRespVo interface.
 */
export function instanceOfResponseListGetDeliverFeeKrAmountlListRespVo(value: object): value is ResponseListGetDeliverFeeKrAmountlListRespVo {
    return true;
}

export function ResponseListGetDeliverFeeKrAmountlListRespVoFromJSON(json: any): ResponseListGetDeliverFeeKrAmountlListRespVo {
    return ResponseListGetDeliverFeeKrAmountlListRespVoFromJSONTyped(json, false);
}

export function ResponseListGetDeliverFeeKrAmountlListRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListGetDeliverFeeKrAmountlListRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(GetDeliverFeeKrAmountlListRespVoFromJSON)),
    };
}

export function ResponseListGetDeliverFeeKrAmountlListRespVoToJSON(json: any): ResponseListGetDeliverFeeKrAmountlListRespVo {
    return ResponseListGetDeliverFeeKrAmountlListRespVoToJSONTyped(json, false);
}

export function ResponseListGetDeliverFeeKrAmountlListRespVoToJSONTyped(value?: ResponseListGetDeliverFeeKrAmountlListRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(GetDeliverFeeKrAmountlListRespVoToJSON)),
    };
}

